import React, { useState, useEffect, useRef } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

function Pagination({ clickForward, clickBackward, page, totalpage, onPageChange }) {
    const [inputValue, setInputValue] = useState(page);
    const [isEditing, setIsEditing] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        setInputValue(page);
    }, [page]);

    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [isEditing]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            submitPage();
        }
    };

    const handleBlur = () => {
        submitPage();
    };

    const submitPage = () => {
        let newPage = parseInt(inputValue, 10);
        if (isNaN(newPage) || newPage < 1) {
            newPage = 1;
        } else if (newPage > totalpage) {
            newPage = totalpage;
        }
        
        if (newPage !== page && onPageChange) {
            onPageChange(newPage);
        } else {
            setInputValue(page);
        }
        setIsEditing(false);
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    return (
      <div className="flex justify-end items-center gap-3 py-4 pr-4">
        {/* Previous Button */}
        <button
          onClick={clickBackward}
          disabled={page <= 1}
          className={`px-4 py-2 rounded-lg flex justify-center items-center gap-2 text-[15px] font-medium transition-all duration-300 ease-in-out
            ${page <= 1 
              ? 'bg-[#F3F4F6] text-[#9CA3AF] cursor-not-allowed border border-transparent' 
              : 'bg-[#5cb87d] text-white shadow-sm active:shadow-sm border border-transparent'
            }`}
        >
          <ChevronLeftIcon className={`w-[18px] h-[18px] stroke-[2.5px] ${page <= 1 ? 'stroke-[#9CA3AF]' : 'stroke-white'}`} />
          <span>Previous</span>
        </button>

        {/* Page Indicator */}
        <div className="flex items-center justify-center min-w-[80px] gap-2 px-4 py-2 bg-white rounded-lg text-[#747081] font-medium border border-[#E0DFE2] shadow-sm">
            {onPageChange ? (
              isEditing ? (
                <input
                  ref={inputRef}
                  type="number"
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  onBlur={handleBlur}
                  className="w-8 text-center text-[#747081] outline-none bg-[#f4f4f4] rounded [-moz-appearance:_textfield] [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none"
                  min={1}
                  max={totalpage}
                />
              ) : (
                <span 
                  className={`text-[#747081] rounded px-1 transition-colors ${totalpage === 0 ? '' : 'cursor-pointer hover:bg-[#f4f4f4]'}`}
                  onClick={() => { if (totalpage > 0) setIsEditing(true); }}
                  title={totalpage === 0 ? "" : "คลิกเพื่อระบุหน้า"}
                >
                  {totalpage === 0 ? 0 : page}
                </span>
              )
            ) : (
              <span className="text-[#747081] px-1">{totalpage === 0 ? 0 : page}</span>
            )}
            <span className="text-[#747081]">/</span>
            <span className="text-[#747081] px-1">{totalpage}</span>
        </div>

        {/* Next Button */}
        <button
          onClick={clickForward}
          disabled={page >= totalpage}
          className={`px-4 py-2 rounded-lg flex justify-center items-center gap-2 text-[15px] font-medium transition-all duration-300 ease-in-out
            ${page >= totalpage 
              ? 'bg-[#F3F4F6] text-[#9CA3AF] cursor-not-allowed border border-transparent' 
              : 'bg-[#5cb87d] text-white shadow-sm active:shadow-sm border border-transparent'
            }`}
        >
          <span>Next</span>
          <ChevronRightIcon className={`w-[18px] h-[18px] stroke-[2.5px] ${page >= totalpage ? 'stroke-[#9CA3AF]' : 'stroke-white'}`} />
        </button>
      </div>
    );
}

export default Pagination
